import { graphql } from '../../gql';

/**
 * Lightweight composition V3 query (headcount only).
 * Used on overview pages where only the headcount line chart is needed.
 * `breakdown_options` is required by the API even when breakdown payloads are unused.
 */
export const COMPOSITION_HEADCOUNT_ONLY_V3 = graphql(`
  query CompositionHeadcountOnlyV3(
    $entities: [CompositionV3Ent!]!
    $filters: CompositionV3Filters!
    $corrections: CompositionV3Corrections!
    $role_taxonomy: Int!
    $skill_taxonomy: Int!
    $breakdown_options: CompositionV3BreakdownOptions!
  ) {
    composition_v3(
      req: {
        entities: $entities
        filters: $filters
        corrections: $corrections
        role_taxonomy: $role_taxonomy
        skill_taxonomy: $skill_taxonomy
        breakdown_options: $breakdown_options
      }
    ) {
      entities {
        id
        short_name
        long_name
        metrics {
          headcount {
            id
            val
          }
        }
      }
    }
  }
`);

export const COMPOSITION_GET_DATA_V3 = graphql(`
  query CompositionV3Data(
    $entities: [CompositionV3Ent!]!
    $filters: CompositionV3Filters!
    $corrections: CompositionV3Corrections!
    $role_taxonomy: Int!
    $skill_taxonomy: Int!
    $breakdown_options: CompositionV3BreakdownOptions!
    $cache_options: ResponseCacheOptions
  ) {
    composition_v3(
      req: {
        entities: $entities
        filters: $filters
        corrections: $corrections
        role_taxonomy: $role_taxonomy
        skill_taxonomy: $skill_taxonomy
        breakdown_options: $breakdown_options
        cache_options: $cache_options
      }
    ) {
      entities {
        id
        short_name
        long_name
        metrics {
          headcount {
            id
            val
          }
          tenure {
            id
            val
          }
          salary {
            id
            val
          }
          growth_rate {
            id
            val
          }
          hiring_rate {
            id
            val
          }
          attrition_rate {
            id
            val
          }
          gender {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          ethnicity {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          role {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          geography {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          seniority {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          education {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          rics {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
          skills {
            id
            rank
            short_name
            long_name
            headcount {
              id
              count
              share
            }
          }
        }
      }
    }
  }
`);

/** Snapshot-style tooltip: headcount + salary timeseries for a single month range. */
export const COMPOSITION_V3_TOOLTIP = graphql(`
  query CompositionV3Tooltip(
    $entities: [CompositionV3Ent!]!
    $filters: CompositionV3Filters!
    $corrections: CompositionV3Corrections!
    $role_taxonomy: Int!
    $skill_taxonomy: Int!
    $breakdown_options: CompositionV3BreakdownOptions!
  ) {
    composition_v3(
      req: {
        entities: $entities
        filters: $filters
        corrections: $corrections
        role_taxonomy: $role_taxonomy
        skill_taxonomy: $skill_taxonomy
        breakdown_options: $breakdown_options
      }
    ) {
      entities {
        id
        short_name
        long_name
        metrics {
          headcount {
            id
            val
          }
          salary {
            id
            val
          }
        }
      }
    }
  }
`);
